module.exports = __webpack_public_path__ + "img/language.142790dc.svg";